export const allPermissionMapping: { [key: string]: string } = {
	// Full Access
	FullAccess: '*',

	// My Account
	AccountMe: 'account.me',
	AccountUpdate: 'account.update',
	AccountChangePassword: 'account.change_password',

	// Storage
	StorageGetCredentials: 'storage.credentials',

	// Roles
	RolesAdd: 'roles.add',
	RolesList: 'roles.list',
	RolesUpdate: 'roles.update',

	//Permissions
	PermissionList: 'permission.list',

	// User Management
	UserCreate: 'user.create',
	UserList: 'user.list',
	UserUpdate: 'user.update',
	UserStatusUpdate: 'user.status.update',
	UserDelete: 'user.delete',
	UserSetCreator: 'user.set.creator',

	// Energy Package
	EnergyPackageAdd: 'energy.package.add',
	EnergyPackageList: 'energy.package.list',
	EnergyPackageUpdate: 'energy.package.update',
	EnergyPackageDelete: 'energy.package.delete',

	// Creators
	CreatorList: 'creator.list',
	CreatorView: 'creator.view',
	CreatorStatusUpdate: 'creator.status.update',
	CreatorAdd: 'creator.add',
	CreatorUpdate: 'creator.update',
	CreatorArchive: 'creator.archive',
	CreatorDelete: 'creator.delete',
	CreatorSubscriptionAdd: 'creator.subscription.add',
	CreatorSubscriptionHistory: 'creator.subscription.history',
	CreatorInfoPostsAdd: 'creator.info.posts.add',
	CreatorInfoPostsUpdate: 'creator.info.posts.update',
	CreatorInfoPostsDelete: 'creator.info.posts.delete',
	CreatorInfoPostsVisibility: 'creator.info.posts.visibility',
	CreatorInfoPostsList: 'creator.info.posts.list',
	CreatorCacheRefresh: 'creator.cache.refresh',
	CreatorPayoutPercentage: 'creator.payout.percentage',
	CreatorMasterOtp: 'creator.master.otp.get',
	CreatorForceLogout: 'creator.force.logout',
	CreatorVoiceMail: 'creator.voice_mail',
	CreatorCallForward: 'creator.call.forward',
	CreatorTemplateMessageGet: 'creator.template.message.get',
	CreatorTemplateMessageUpdate: 'creator.template.message.update',
	CreatorSmsCreditAdd: 'creator.sms.credit.add',
	CreatorBlockLimitGet: 'poll.limit.get',
	CreatorBlockLimitUpdate: 'poll.limit.update',
	CreatorDownloadFans: 'creator.download.fans',
	CreatorExport: 'creator.export',
	CreatorPhoneNumberStatus: 'creator.assignments.get',
	CreatorBrandUpdate: 'creator.brand.update',
	CreatorCreditNoteView: 'creator.credit_note.view',

	// Payouts
	PayoutsGet: 'payouts.get',
	PayoutApprove: 'payout.approve',

	// Creator Config
	CreatorConfigPlanList: 'creator.config.plan.list',
	CreatorConfigPlanDelete: 'creator.config.plan.delete',
	CreatorConfigPlanUpdate: 'creator.config.plan.update',

	// Rewards
	RewardList: 'reward.list',
	RewardAdd: 'reward.add',
	RewardUpdate: 'reward.update',
	RewardDelete: 'reward.delete',
	CatchThePrizeBoard: 'reward.board',
	BanCatchThePrizeUser: 'ban.prize_run.user',
	UnbanCatchThePrizeUser: 'unban.prize_run.user',
	BanAndUnBanUserList: 'get.prize_run.users',

	// Interactions
	InteractionList: 'interaction.list',
	InteractionAdd: 'interaction.add',
	InteractionUpdate: 'interaction.update',
	InteractionDelete: 'interaction.delete',

	// OBS
	OBSConfigView: 'obs.config.view',
	OBSConfigUpdate: 'obs.config.update',
	OBSElementActivate: 'obs.element.activate',
	OBSElementClear: 'obs.element.clear',
	OBSElementLeaderboard: 'obs.element.leaderboard',
	OBSElementReferUrl: 'obs.element.referurl',
	OBSElementChatBoxActivate: 'obs.chat_box.activate',
	OBSGetActiveReferUrl: 'obs.active.referurl',

	// Polls
	PollEnd: 'poll.end',
	PollStart: 'poll.start',
	PollUpdate: 'poll.update',
	PollDelete: 'poll.delete',
	PollListResults: 'poll.list.results',
	PollApplicantList: 'poll.applicant.list',
	PollApplicantUpdateStatus: 'poll.applicant.update.status',
	PollWinner: 'poll.winner',
	PollHide: 'poll.hide',
	PollSetOptResult: 'poll.set.opt.result',
	PollView: 'poll.view',
	PollListByTypeState: 'poll.list.type.state',

	// Application form
	ApplicationFormCreate: 'app.form.create',
	ApplicationFormUpdate: 'app.form.update',
	ApplicationFormDelete: 'app.form.delete',
	ApplicationFormGroupUpdate: 'app.form.group.update',
	ApplicationFormFieldCreate: 'app.form.field.create',
	ApplicationFormFieldUpdate: 'app.form.field.update',
	ApplicationFormFieldDelete: 'app.form.field.delete',
	ApplicationFormView: 'app.form.view',
	ApplicantBulkAddToWinner: 'applicant.bulk.add.winner',

	// Refer Url
	ReferUrlAdd: 'refer.url.add',
	ReferUrlUpdate: 'refer.url.update',
	ReferUrlList: 'refer.url.list',
	ReferUrlChangeStatus: 'refer.url.change.status',

	// Explore All
	ExploreAll: 'explore.all',

	// Fan user
	FanUserGet: 'fan.user.get',
	FanUserList: 'fan.user.list',

	// Chat Moderator
	ChatModeratorGetWildcardAccess: 'chat.wildcard.access',
	ChatModeratorGetCreatorAccess: 'chat.creator.access',
	ChatModeratorSetMessageFlag: 'chat.message.setflag',
	ChatModeratorRemoveMessageFlag: 'chat.message.removeflag',
	ChatModeratorGetConfig: 'chat.config.get',
	ChatModeratorConfigUpdate: 'chat.config.update',
	ChatModeratorBanUser: 'chat.ban.user',
	ChatModeratorUnBanUser: 'chat.unban.user',
	ChatModeratorBanUserList: 'chat.ban.user.list',

	// Gift Events
	GiftEventCreate: 'gift.event.create',
	GiftEventUpdate: 'gift.event.update',
	GiftEventGet: 'gift.event.get',
	GiftEventActivate: 'gift.event.activate',

	// Early Access
	EarlyAccessGet: 'early.access.get',
	EarlyAccessGenerateCode: 'early.access.generatecode',
	EarlyAccessCreate: 'early.access.create',

	//Sms Package List
	SmsPackageAdd: 'sms.package.add',
	SmsPackageList: 'sms.package.list',
	SmsPackageUpdate: 'sms.package.update',
	SmsPackageDelete: 'sms.package.delete',
	SmsPackageIncreases: 'sms.package.increase',

	//Creator Bonus List
	BonusList: 'payout.bonus.list',
	BonusCredit: 'payout.bonus.credit',

	// Fan Payment
	FanPaymentEnergyList: 'fan.payment.energy.list',
	FanPaymentVipList: 'fan.payment.vip.list',
	FanPaymentDirectPurchaseList: 'fan.payment.direct.purchase.list',
	FanPaymentSuperSmsList: 'fan.payment.super.sms.list',
	FanPaymentTipList: 'fan.payment.tip.list',
	FanPaymentSignUpList: 'fan.payment.pay_to_sign_up.list',
	FanPaymentAllList: 'fan.payment.all.list',

	//Creator Payment
	CreatorPayment: 'creator.payment.sms.list',
	CreatorPaymentSubscriptionList: 'creator.payment.subscription.list',

	//Assigned Sms Credits
	AssignedSmsCredits: 'assigned.sms.credits.list',

	//Vault
	FolderAdd: 'folder.add',
	FolderMediaAdd: 'folder.media.add',
	FolderMediaUpdate: 'folder.media.update',
	FolderGet: 'folder.get',
	FolderMediaGet: 'folder.media.get',
	FolderDelete: 'folder.delete',
	FolderMediaDelete: 'folder.media.delete',
	FolderUpdate: 'folder.update',
	FolderMediaUpdateItem: 'folder.media.update_item',
	FolderMediaSafe: 'folder.media.safe',

	//Dashboard
	DashboardView: 'dashboard.view',

	//Chat
	ChatExport: 'chat.export',

	//Bmmanagement
	BMMaster: 'bm.master',
	BillingUpdate: 'billing.update',

	//Billing
	Billing: 'billing.view',

	// Customer Info, Bank Details, Affiliates (view)
	CustomerInfoView: 'customer.info.view',
	BankDetailsView: 'bank.details.view',
	AffiliatesView: 'affiliates.view',

	CreditNotesList: 'credit_notes.list',
	CreditNotesGet: 'credit_notes.get',
	CreditNotesMakeApprove: 'credit_notes.make.approve',
	CreditNotesMakePaid: 'credit_notes.make.paid',
	CreditNotesUpdate: 'credit_notes.update',
	CreditNotesRegenerate: 'credit_notes.regenerate',
	CreditNotesPreview: 'credit_notes.preview',
	CreditNotesRevertStatus: 'credit_notes.revert.status',
	CreditNotesMakeNotRelevant: 'credit_notes.make.not_relevant',
	CreditNotesSetNote: 'credit_notes.set.note',

	//Telegram groups
	TelegramGroupList: 'telegram.group.list',
	TelegramGroupUpdate: 'telegram.group.update',

	//Telegram Messages
	TelegramMessageList: 'telegram.message.list',
	TelegramMessageSend: 'telegram.message.send',

	// AI
	AiConversationList: 'ai.conversation.list',
	AiConversationAsk: 'ai.conversation.ask',
	AiConversationGet: 'ai.conversation.get',
	AiConversationUpdateTitle: 'ai.conversation.update.title',
	AiConversationDelete: 'ai.conversation.delete'
};

export const RENAMED_PERMISSIONS: { [key: string]: string } = {
	'*': 'Full Access',
	'account.me': `Profile View`,
	'account.update': 'Profile Update',
	'account.change_password': 'Change Password',
	'storage.credentials': 'Allow Storage Credential',
	'roles.add': 'Add New Role',
	'roles.list': 'View Role List',
	'roles.update': 'Update Created Role',
	'permission.list': 'Get Permissions List',
	'user.create': 'Create User',
	'user.list': 'View User List',
	'user.update': 'Update User',
	'user.status.update': 'Update User Status',
	'user.delete': 'Delete User',
	'user.set.creator': 'Allow Set creators to user',
	'energy.package.add': 'Add New Price(Shop)',
	'energy.package.list': 'View Prices(Energy Package) List',
	'energy.package.update': 'Update Prices(Energy Package)',
	'energy.package.delete': 'Delete Prices(Energy Package)',
	'creator.list': 'View Creator List',
	'creator.view': 'View Creator Detail',
	'creator.status.update': 'Update Creator Status',
	'creator.add': 'Create New Creator',
	'creator.update': 'Update New Creator',
	'creator.archive': 'Archive Creator',
	'creator.delete': 'Force Delete Creator',
	'creator.brand.update': 'Creator brand update',
	'creator.subscription.add': 'Set Creator Subscription Plan',
	'creator.subscription.history': 'View Creator Subscription History',
	'creator.info.posts.add': 'Add Info Post',
	'creator.info.posts.update': 'Update Info Post',
	'creator.info.posts.delete': 'Delete Info Post',
	'creator.info.posts.visibility': 'Hide/Unhide Info Post',
	'creator.info.posts.list': 'View Info Post List',
	'creator.config.plan.list': 'Creator Subscription Plan List',
	'creator.config.plan.delete': 'Delete Creator Subscription Plan',
	'creator.config.plan.update': 'Update Creator Subscription Plan',
	'payouts.get': 'View Payouts',
	'payout.approve': 'Approve Payout',
	'creator.cache.refresh': 'Refresh Creator Cache',
	'creator.payout.percentage': 'Creator Payout Percentage',
	'reward.list': 'View Rewards List',
	'reward.add': 'Create New Rewards',
	'reward.update': 'Update Rewards',
	'reward.delete': 'Delete Rewards List',
	'interaction.list': 'View Interactions List',
	'interaction.add': 'Add New Interactions',
	'interaction.update': 'Update Interactions',
	'interaction.delete': 'Delete Interactions',
	'obs.config.view': 'Enable OBS Overlay',
	'obs.config.update': 'Update OBS Config',
	'obs.element.activate': 'Allow OBS Manaual Push Element',
	'obs.element.clear': 'Clear OBS Elements',
	'obs.element.leaderboard': 'Push Leader on OBS',
	'obs.element.referurl': 'Push Refer URL on OBS',
	'obs.chat_box.activate': 'Push Chat on OBS',
	'obs.active.referurl': 'View Active Refer URLS While Pushing Refer URL to OBS',
	'poll.end': 'End Active Poll',
	'poll.start': 'Activate Poll(Interactions/Rewards)',
	'poll.update': 'Update Activated Poll',
	'poll.delete': 'Delete Activated Poll',
	'poll.list.results': 'Activate Show Winners Button',
	'poll.applicant.list': 'Activate View Applicants Button',
	'poll.applicant.update.status': 'Allow Status Update of Applicants',
	'poll.winner': 'Allow Add Manual Application Winner ',
	'poll.hide': 'Hide/Unhide Activated Poll',
	'poll.set.opt.result': 'Activate Set Prediction Winner Button',
	'poll.view': 'Allow View Application Page Winner',
	'poll.list.type.state': 'View Active Poll List/View OBS List',
	'app.form.create': 'Create Application Form',
	'app.form.update': 'Update Application Form',
	'app.form.delete': 'Delete Application Form',
	'app.form.group.update': 'Update Application Page Builder',
	'app.form.field.create': 'Add New Field in Application page',
	'app.form.field.update': 'Update Field in Application page',
	'app.form.field.delete': 'Delete Field From Application page',
	'app.form.view': 'View Applicaion Page Builder',
	'applicant.bulk.add.winner': 'Set Winners form Application Form',
	'refer.url.add': 'Create New Refer URL',
	'refer.url.update': 'Update Refer URL',
	'refer.url.list': 'View Refer URL',
	'refer.url.change.status': 'Update Status of Refer URL',
	'explore.all': 'Allow Access of Explore Page Modification',
	'fan.user.get': 'View Creator Detail',
	'fan.user.list': 'Fan user list',
	'chat.wildcard.access': 'Allow Chat Access',
	'chat.creator.access': 'Allow Support Chat Access',
	'chat.message.setflag': 'Allow Delete Message From Chat',
	'chat.message.removeflag': 'Allow Retrive Deleted Message to Chat',
	'chat.config.get': 'Allow Modification of Chat Config',
	'chat.config.update': 'Allow Modification of Chat Config',
	'chat.ban.user': 'Allow Ban User From Chat',
	'chat.unban.user': 'Allow Unban User From Chat',
	'chat.ban.user.list': 'Allow to View Ban User List',
	'gift.event.create': 'Create New Gift Event',
	'gift.event.update': 'Update Gift Event',
	'gift.event.get': 'View Gift Event List',
	'gift.event.activate': 'Allow Activation Of Gift Event',
	'early.access.get': 'View Early Access List',
	'early.access.generatecode': 'Allow Generate Early Access Code',
	'early.access.create': 'Allow Create new Eaarly Access',
	'reward.board': 'Catch the prize Leaderboard',
	'ban.prize_run.user': 'Ban Catch the prize User',
	'unban.prize_run.user': 'Unban Catch the prize User',
	'get.prize_run.users': 'View ban and unban users',
	'sms.package.add': 'Add Sms Package',
	'sms.package.list': 'List Sms Package',
	'sms.package.update': 'Update Sms Package',
	'sms.package.delete': 'Delete Sms Package',
	'sms.package.increase': 'Increase Sms Package',
	'fan.payment.energy.list': 'Fan Payment Energy List',
	'fan.payment.vip.list': 'Fan Payment Vip List',
	'fan.payment.direct.purchase.list': 'Fan Payment Direct Purchase List',
	'creator.payment.sms.list': 'Creator Sms Payment List',
	'creator.payment.subscription.list': 'Creator Subscription Payment List',
	'payout.bonus.credit': 'Payout Bonus Credit',
	'payout.bonus.list': 'Payout Bonus List',
	'assigned.sms.credits.list': 'Assigned Sms Credits List',
	'dashboard.view': 'Dashboard View',
	'chat.export': 'Chat Export',
	'fan.payment.super.sms.list': 'Fan Payment SuperSms List',
	'fan.payment.tip.list': 'Fan Payment Tip List',
	'fan.payment.pay_to_sign_up.list': 'Fan Payment PayToSignUp list',
	'fan.payment.all.list': 'Fan Payment All Transaction List',
	'folder.add': 'Folder Add',
	'folder.media.add': 'Folder Media Add',
	'folder.media.update': 'Folder Media Update',
	'folder.get': 'Folder Get',
	'folder.media.get': 'Folder Media Get',
	'folder.delete': 'Folder Delete',
	'folder.media.delete': 'Folder Media Delete',
	'folder.update': 'Folder Update',
	'folder.media.update_item': 'Folder Media update item',
	'folder.media.safe': 'Folder Media safe',
	'creator.master.otp.get': 'Master OTP',
	'creator.force.logout': 'Creator Force Logout',
	'creator.voice_mail': 'Creator Voice Mail',
	'creator.call.forward': 'Creator Call Forward',
	'creator.template.message.get': 'Creator Template Message Get',
	'creator.template.message.update': 'Creator Template Message Update',
	'creator.sms.credit.add': 'Creator Sms Credit Add',
	'creator.fanPaymentUpdate.update': 'Fan Payment Method Update',
	'creator.export': 'All Creator Detail Export',
	'creator.assign.gift-membership': 'Assign Gift Membership',
	'creator.assignments.get': 'Phone number status',
	'creator.credit_note.view': 'Credit note tab',
	'poll.limit.get': 'Creator Block Limit get',
	'poll.limit.update': 'Creator Block limit Update',
	'creator.download.fans': 'Creator Download Fans',
	'bm.master': 'Master BM',
	'billing.update': 'Billing Update',
	'billing.view': 'Billing View',
	'customer.info.view': 'View Customer Info',
	'bank.details.view': 'View Bank Details',
	'affiliates.view': 'View Affiliates',
	'credit_notes.list': 'Credit Note List',
	'credit_notes.get': 'Credit Note Details',
	'credit_notes.make.approve': 'Approve Credit Note',
	'credit_notes.make.paid': 'Paid Credit Note',
	'credit_notes.update': 'Update Credit Note',
	'credit_notes.regenerate': 'Credit Note Regenerate',
	'credit_notes.preview': 'Credit Note Preview',
	'credit_notes.revert.status': 'Credit Note Revert Status',
	'credit_notes.make.not_relevant': 'Credit Note Make Relevant',
	'credit_notes.set.note': 'Credit Note Set Note',
	'telegram.group.list': 'Telegram Group List',
	'telegram.group.update': 'Telegram Group Update',
	'telegram.message.list': 'Telegram Message List',
	'telegram.message.send': 'Telegram Message Send',
	'ai.conversation.list': 'AI Conversation List',
	'ai.conversation.ask': 'AI Conversation Ask',
	'ai.conversation.get': 'AI Conversation Get',
	'ai.conversation.update.title': 'AI Conversation Update Title',
	'ai.conversation.delete': 'AI Conversation Delete'
};

export const APPLICATION_EDIT_BUTTON_PERMISSIONS = ['ApplicationFormGroupUpdate', 'ApplicationFormUpdate'];

export const SET_SUBSCRIPTION_BUTTON_PERMISIIONS = ['CreatorSubscriptionAdd', 'CreatorSubscriptionUpdate'];

export const CHAT_DELETE_PERMISSIONS = ['ChatModeratorSetMessageFlag', 'ChatModeratorRemoveMessageFlag'];

export const USER_BAN_UNBAN_PERMISSIONS = ['ChatModeratorBanUser', 'ChatModeratorUnBanUser'];
